window.KnifeCustomizationState = {
    selectedShape: null,
    selectedBlade: null,
    selectedBladeData: null,
    selectedHandle: null,
    selectedHandleData: null,
    setSelectedShape: null,
    setSelectedBlade: null,
    setSelectedHandle: null,
    activeAccordion: 'shape',
    setActiveAccordion: null,
    allBlades: [],
    allHandles: [],
    allShapes: []
};

const SHAPE_TO_TAG = {
    'santoku': 'Santoku',
    'nakiri': 'Nakiri',
    'gyuto': 'Gyuto',
    'bunka': 'Bunka',
    'kobunka': 'Kobunka',
    'petty': 'Petty',
    'kiritsuke-petty': 'Kiritsuke Petty',
    'kiritsuke': 'Kiritsuke'
};

const TAG_TO_SHAPE = {
    'Santoku': 'santoku',
    'Nakiri': 'nakiri',
    'Gyuto': 'gyuto',
    'Bunka': 'bunka',
    'Kobunka': 'kobunka',
    'Petty': 'petty',
    'Kiritsuke Petty': 'kiritsuke-petty',
    'Kiritsuke': 'kiritsuke'
};

const DEFAULT_HANDLE_PREVIEW_SHAPE = 'santoku';

const mockKnifeShapes = [
    { id: 'santoku', name: 'Santoku', description: 'The Santoku is a versatile Japanese all-purpose knife, perfect for slicing, dicing, and mincing vegetables, fish, and meat with precision.', image: '' },
    { id: 'nakiri', name: 'Nakiri', description: 'The Nakiri is a Japanese vegetable knife with a flat blade profile, designed for precise up-and-down chopping of vegetables.', image: '' },
    { id: 'gyuto', name: 'Gyuto', description: 'The Gyuto is the Japanese equivalent of a Western chef knife, offering versatility for all kitchen tasks from slicing to fine dicing.', image: '' },
    { id: 'bunka', name: 'Bunka', description: 'A versatile all-rounder designed for both precision and power. The Bunka distinct reverse tanto tip allows for detailed work like slicing herbs or vegetables, while its broad blade excels at chopping and cutting meats.', image: '' },
    { id: 'kobunka', name: 'Kobunka', description: 'The Kobunka is a smaller version of the Bunka, offering the same versatile design in a more compact form for detailed work and smaller hands.', image: '' },
    { id: 'petty', name: 'Petty', description: 'The Petty is a small utility knife perfect for intricate tasks like peeling, trimming, and detailed cutting work.', image: '' },
    { id: 'kiritsuke-petty', name: 'Kiritsuke Petty', description: 'The Kiritsuke Petty combines the elegant clipped tip of a Kiritsuke with the compact utility of a Petty knife for versatile precision work.', image: '' },
    { id: 'kiritsuke', name: 'Kiritsuke', description: 'The Kiritsuke is a prestigious Japanese knife traditionally reserved for executive chefs, combining the functions of both Yanagiba and Usuba.', image: '' }
];

const shapeImages = {
    santoku: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-santoku.png?v=1769401464',
    nakiri: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-nakiri.png?v=1769401464',
    gyuto: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-gyuto.png?v=1769401464',
    bunka: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-bunka.png?v=1769401464',
    kobunka: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-kobunka.png?v=1769401464',
    petty: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-petty.png?v=1769401464',
    'kiritsuke-petty': 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-kiritsuke-petty.png?v=1769401464',
    kiritsuke: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-kiritsuke.png?v=1769401464'
};

const BLADE_SPECS_CONFIG = [
    { key: 'custom.product_name_japanese', label: 'Product Name (Japanese)' },
    { key: 'my_fields.blade_type', label: 'Blade Type' },
    { key: 'custom.blade_shape', label: 'Blade Shape' },
    { key: 'custom.blade_use', label: 'Use' },
    { key: 'my_fields.blade_material', label: 'Blade Material' },
    { key: 'my_fields.material_detail', label: 'Material Detail' },
    { key: 'my_fields.blade_finish', label: 'Blade Finish' },
    { key: 'my_fields.finish_detail', label: 'Finish Detail' },
    { key: 'my_fields.hrc', label: 'HRC' },
    { key: 'my_fields.weght', label: 'Weight' },
    { key: 'custom.total_length', label: 'Total Length' },
    { key: 'my_fields.blade_length', label: 'Blade Length' },
    { key: 'custom.blade_width', label: 'Blade Width' },
    { key: 'custom.blade_height', label: 'Blade Height' },
    { key: 'my_fields.blade_thickness', label: 'Blade Thickness' },
    { key: 'custom.spine_length', label: 'Spine Length' },
    { key: 'custom.spine_thickness', label: 'Spine Thickness' },
    { key: 'custom.handle_length', label: 'Handle Length (Recommended)' },
    { key: 'my_fields.origin', label: 'Origin' },
    { key: 'my_fields.availability_sheath', label: 'Sheath Availability' }
];

const HANDLE_SPECS_CONFIG = [
    { key: 'custom.handle_length', label: 'Handle Length' },
    { key: 'my_fields.weght', label: 'Weight' },
    { key: 'custom.handle_thickness', label: 'Handle Thickness (Top)' },
    { key: 'custom.handle_thickness_bottom', label: 'Handle Thickness (Bottom)' },
    { key: 'custom.ferrule_length', label: 'Ferrule Length' },
    { key: 'custom.tang_size', label: 'Tang Size' },
    { key: 'my_fields.material_detail', label: 'Material Detail' },
    { key: 'custom.colour', label: 'Colour' },
    { key: 'my_fields.finish_detail', label: 'Finish Detail' },
    { key: 'custom.handle_end', label: 'Handle End' }
];

function formatPrice(price) {
    if (window.CurrencyFormat && window.CurrencyFormat.formatMoney) {
        return window.CurrencyFormat.formatMoney(price);
    }
    return '¥' + price.toLocaleString() + ' JPY';
}

function preloadImages(imageUrls) {
    var validUrls = imageUrls.filter(function(url) { return url && url.length > 0; });
    if (validUrls.length === 0) {
        return Promise.resolve();
    }
    
    var promises = validUrls.map(function(url) {
        return new Promise(function(resolve) {
            var img = new Image();
            img.onload = resolve;
            img.onerror = resolve;
            img.src = url;
        });
    });
    
    return Promise.all(promises);
}

function preloadSingleImage(imageUrl) {
    return new Promise(function(resolve) {
        if (!imageUrl || imageUrl.length === 0) {
            resolve(true);
            return;
        }
        var img = new Image();
        img.onload = function() { resolve(true); };
        img.onerror = function() { resolve(true); };
        img.src = imageUrl;
    });
}

function getShapeFromBladeTags(tags) {
    if (!tags || !Array.isArray(tags)) return null;
    
    for (var i = 0; i < tags.length; i++) {
        if (TAG_TO_SHAPE[tags[i]]) {
            return TAG_TO_SHAPE[tags[i]];
        }
    }
    return null;
}

function bladeMatchesShape(blade, shapeId) {
    if (!blade || !blade.tags || !shapeId) return false;
    var shapeTag = SHAPE_TO_TAG[shapeId];
    return blade.tags.includes(shapeTag);
}

function getCompatibleShapesFromHandle(handle) {
    if (!handle || !handle.tags || !Array.isArray(handle.tags)) return [];
    
    var compatibleShapes = [];
    handle.tags.forEach(function(tag) {
        if (tag.startsWith('fits-')) {
            var shapeId = tag.replace('fits-', '');
            if (SHAPE_TO_TAG[shapeId]) {
                compatibleShapes.push(shapeId);
            }
        }
    });
    return compatibleShapes;
}

function handleFitsShape(handle, shapeId) {
    if (!handle || !shapeId) return false;
    var compatibleShapes = getCompatibleShapesFromHandle(handle);
    return compatibleShapes.includes(shapeId);
}

function bladeCompatibleWithHandle(blade, handle) {
    if (!blade || !handle) return true;
    var bladeShape = getShapeFromBladeTags(blade.tags);
    if (!bladeShape) return true;
    return handleFitsShape(handle, bladeShape);
}

function handleHasBladeRestrictions(handle) {
    if (!handle || !handle.tags) return false;
    return handle.tags.includes('ocean');
}

function bladeFitsHandle(blade, handle) {
    if (!blade || !handle) return true;
    
    if (!handleHasBladeRestrictions(handle)) {
        return true;
    }
    
    return blade.tags && blade.tags.includes('fits-ocean');
}

function handleFitsBlade(handle, blade) {
    if (!handle || !blade) return true;
    
    if (!handleHasBladeRestrictions(handle)) {
        return true;
    }
    
    return blade.tags && blade.tags.includes('fits-ocean');
}

function getHandlePreviewImage(handle, shapeId) {
    if (!handle || !handle.metafields) return handle?.image || '';
    
    var shape = shapeId || DEFAULT_HANDLE_PREVIEW_SHAPE;
    var metafieldKey = 'custom.handle_' + shape.replace('-', '_') + '_preview';
    
    return handle.metafields[metafieldKey] || 
           handle.metafields['custom.handle_' + DEFAULT_HANDLE_PREVIEW_SHAPE + '_preview'] || 
           handle.image || 
           '';
}

function getSpecifications(product, imageType) {
    var metafields = product.metafields || {};
    var specsConfig = [];
    
    if (imageType === 'blade') {
        specsConfig = BLADE_SPECS_CONFIG;
    } else if (imageType === 'handle') {
        specsConfig = HANDLE_SPECS_CONFIG;
    }
    
    return specsConfig.map(function(spec) {
        return {
            label: spec.label,
            value: metafields[spec.key] || '-'
        };
    });
}

function getRecommendedHandles(product) {
    if (!product.metafields) return [];
    return product.metafields['custom.recommended_handles'] || [];
}

window.getHandlePreviewImage = getHandlePreviewImage;
window.getShapeFromBladeTags = getShapeFromBladeTags;
window.DEFAULT_HANDLE_PREVIEW_SHAPE = DEFAULT_HANDLE_PREVIEW_SHAPE;

// Link icon component for View Product button
function LinkIcon() {
    return React.createElement('svg', {
        width: '16',
        height: '16',
        viewBox: '0 0 40 40',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
        style: { marginLeft: '4px', verticalAlign: 'middle' }
    },
        React.createElement('path', {
            d: 'M33.75 16.25L33.7484 6.25156L23.75 6.25M21.25 18.75L33.75 6.25',
            stroke: 'rgba(255, 255, 255, 0.45)',
            strokeWidth: '3',
            strokeLinecap: 'round',
            strokeLinejoin: 'round'
        }),
        React.createElement('path', {
            d: 'M28.75 21.25V32.5C28.75 32.8315 28.6183 33.1495 28.3839 33.3839C28.1495 33.6183 27.8315 33.75 27.5 33.75H7.5C7.16848 33.75 6.85054 33.6183 6.61612 33.3839C6.3817 33.1495 6.25 32.8315 6.25 32.5V12.5C6.25 12.1685 6.3817 11.8505 6.61612 11.6161C6.85054 11.3817 7.16848 11.25 7.5 11.25H18.75',
            stroke: 'rgba(255, 255, 255, 0.45)',
            strokeWidth: '3',
            strokeLinecap: 'round',
            strokeLinejoin: 'round'
        })
    );
}

function ProductPopup(props) {
    var isOpen = props.isOpen;
    var onClose = props.onClose;
    var product = props.product;
    var imageType = props.imageType;
    
    // Image loading state for smooth transitions
    var imageLoadedState = React.useState(false);
    var imageLoaded = imageLoadedState[0];
    var setImageLoaded = imageLoadedState[1];
    var currentImageRef = React.useRef(null);
    
    // MOVED: Define previewImage BEFORE useEffect that uses it
    var previewImage = '';
    if (product) {
        if (imageType === 'shape' && shapeImages[product.id]) {
            previewImage = shapeImages[product.id];
        } else if (product.image) {
            previewImage = product.image;
        }
    }
    
    // Image loading effect
    React.useEffect(function() {
        console.log('Image effect triggered:', previewImage);
        console.log('Current ref:', currentImageRef.current);
        console.log('imageLoaded state:', imageLoaded);
        
        if (previewImage !== currentImageRef.current) {
            currentImageRef.current = previewImage;
            setImageLoaded(false);
            console.log('Set imageLoaded to FALSE');
            
            if (previewImage) {
                var img = new Image();
                img.onload = function() {
                    console.log('Image loaded!');
                    if (previewImage === currentImageRef.current) {
                        setImageLoaded(true);
                    }
                };
                img.onerror = function() {
                    console.log('Image error!');
                    if (previewImage === currentImageRef.current) {
                        setImageLoaded(true);
                    }
                };
                img.src = previewImage;
            } else {
                setImageLoaded(true);
            }
        }
    }, [previewImage]);
    
    React.useEffect(function() {
        var handleEscape = function(e) {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
        }
        return function() {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isOpen, onClose]);
    
    // Early returns AFTER all hooks
    if (!product) return null;
    if (typeof window.antd === 'undefined') return null;
    
    var Tabs = window.antd.Tabs;
    var ConfigProvider = window.antd.ConfigProvider;
    var theme = window.antd.theme;
    
    var specifications = getSpecifications(product, imageType);
    var recommendedHandles = imageType === 'blade' ? getRecommendedHandles(product) : [];
    
    var tabItems = [
        {
            key: '1',
            label: 'Description',
            children: React.createElement('div', { 
                className: 'popup-description' 
            }, product.description)
        }
    ];
    
    if (imageType !== 'shape') {
        tabItems.push({
            key: '2',
            label: 'Specifications',
            children: React.createElement('div', {
                className: 'product-specs-section'
            },
                React.createElement('div', {
                    className: 'product-specs-container'
                },
                    React.createElement('div', {
                        className: 'specs-table-wrapper'
                    },
                        React.createElement('table', {
                            className: 'specs-table'
                        },
                            React.createElement('tbody', null,
                                specifications.map(function(spec, index) {
                                    return React.createElement('tr', { 
                                        key: index
                                    },
                                        React.createElement('td', { 
                                            className: 'spec-label'
                                        }, spec.label),
                                        React.createElement('td', { 
                                            className: 'spec-value'
                                        }, spec.value)
                                    );
                                })
                            )
                        )
                    ),
                    imageType === 'blade' && recommendedHandles.length > 0 && 
                        React.createElement('div', {
                            style: {
                                marginTop: '24px',
                                paddingTop: '24px',
                                borderTop: '1px solid rgba(255, 255, 255, 0.1)'
                            }
                        },
                            React.createElement('div', {
                                style: {
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    color: 'rgba(255, 255, 255, 0.9)',
                                    marginBottom: '16px'
                                }
                            }, 'Recommended Handles'),
                            React.createElement('div', {
                                style: {
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fill, minmax(80px, 1fr))',
                                    gap: '12px'
                                }
                            },
                                recommendedHandles.map(function(handle, index) {
                                    return React.createElement('div', {
                                        key: index,
                                        style: {
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: '8px'
                                        }
                                    },
                                        React.createElement('div', {
                                            style: {
                                                width: '70px',
                                                height: '70px',
                                                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                                                borderRadius: '4px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                overflow: 'hidden',
                                                border: '1px solid rgba(255, 255, 255, 0.1)'
                                            }
                                        },
                                            handle.image ? 
                                                React.createElement('img', {
                                                    src: handle.image,
                                                    alt: handle.title,
                                                    style: {
                                                        maxWidth: '100%',
                                                        maxHeight: '100%',
                                                        objectFit: 'contain'
                                                    }
                                                }) :
                                                React.createElement('span', {
                                                    style: {
                                                        color: 'rgba(255, 255, 255, 0.3)',
                                                        fontSize: '10px'
                                                    }
                                                }, 'No image')
                                        ),
                                        React.createElement('span', {
                                            style: {
                                                fontSize: '11px',
                                                color: 'rgba(255, 255, 255, 0.6)',
                                                textAlign: 'center',
                                                lineHeight: '1.2'
                                            }
                                        }, handle.title)
                                    );
                                })
                            )
                        )
                )
            )
        });
    }
    
    return React.createElement('div', { 
        className: 'popup-overlay' + (isOpen ? ' active' : ''), 
        onClick: onClose
    },
        React.createElement('div', { 
            className: 'popup-content',
            onClick: function(e) { e.stopPropagation(); },
            style: {
                maxHeight: '85vh',
                height: '85vh',
                overflowY: 'auto',
                position: 'relative',
                msOverflowStyle: 'none',
                scrollbarWidth: 'none'
            }
        },
            React.createElement('button', { 
                className: 'popup-close', 
                onClick: onClose
            },
                React.createElement('svg', { 
                    fill: 'none', 
                    stroke: 'currentColor', 
                    viewBox: '0 0 24 24'
                },
                    React.createElement('path', { 
                        strokeLinecap: 'round', 
                        strokeLinejoin: 'round', 
                        strokeWidth: 2, 
                        d: 'M6 18L18 6M6 6l12 12' 
                    })
                )
            ),
            
            React.createElement('div', {
                style: {
                    width: '100%',
                    height: '80%',
                    marginBottom: '24px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.2)',
                    borderRadius: '2px',
                    clear: 'both',
                    overflow: 'hidden'
                }
            },
                previewImage ? (
                    !imageLoaded ? 
                        React.createElement('div', {
                            className: 'popup-image-skeleton',
                            style: {
                                width: '100%',
                                height: '100%',
                                minHeight: '300px'
                            }
                        }) :
                        React.createElement('img', {
                            src: previewImage,
                            alt: product.name,
                            style: {
                                maxWidth: '100%',
                                objectFit: 'contain',
                                animation: 'popupImageFadeIn 0.3s ease-out forwards'
                            }
                        })
                ) : null
            ),
            
            // Title row with View Product button
            React.createElement('div', {
                className: 'popup-title-row'
            },
                React.createElement('h3', { 
                    className: 'popup-title' 
                }, product.name),
                imageType !== 'shape' && React.createElement('a', {
                    href: '/products/' + product.id,
                    target: '_blank',
                    rel: 'noopener noreferrer',
                    className: 'popup-view-product-btn',
                    onClick: function(e) { e.stopPropagation(); }
                }, 'View Product', React.createElement(LinkIcon))
            ),
            
            imageType !== 'shape' && React.createElement('p', { 
                className: 'popup-description', 
                style: { marginTop: '16px' } 
            },
                React.createElement('strong', null, 'Price:'), 
                ' ' + formatPrice(product.price)
            ),
            
            React.createElement(ConfigProvider, {
                theme: {
                    algorithm: theme.darkAlgorithm,
                    token: {
                        colorPrimary: 'rgba(255, 255, 255, 0.6)',
                        colorBgContainer: '#1a1a1a',
                        colorBorder: 'rgba(255, 255, 255, 0.2)',
                        colorText: 'rgba(255, 255, 255, 0.6)',
                        colorTextSecondary: 'rgba(255, 255, 255, 0.45)',
                        fontSize: 14,
                        borderRadius: 2
                    },
                    components: {
                        Tabs: {
                            inkBarColor: 'rgba(255, 255, 255, 0.6)',
                            itemSelectedColor: 'rgba(255, 255, 255, 0.9)',
                            itemColor: 'rgba(255, 255, 255, 0.45)',
                            itemHoverColor: 'rgba(255, 255, 255, 0.7)'
                        }
                    }
                }
            },
                React.createElement(Tabs, {
                    defaultActiveKey: '1',
                    style: { marginTop: '24px' },
                    items: tabItems
                })
            )
        )
    );
}

function SkeletonLoader(props) {
    var count = props.count || 4;
    return React.createElement(React.Fragment, null,
        [...Array(count)].map(function(_, index) {
            return React.createElement('div', { key: index, className: 'skeleton-wrapper' },
                React.createElement('div', { className: 'skeleton-option' },
                    React.createElement('div', { className: 'skeleton skeleton-image' }, '\u00A0')
                ),
                React.createElement('div', { className: 'skeleton skeleton-text' }, '\u00A0'),
                React.createElement('div', { className: 'skeleton skeleton-price' }, '\u00A0')
            );
        })
    );
}

function ProductCard(props) {
    var product = props.product;
    var isSelected = props.isSelected;
    var onSelect = props.onSelect;
    var onTooltipClick = props.onTooltipClick;
    var showPrice = props.showPrice;
    var getImageUrl = props.getImageUrl;
    
    var imageLoadedState = React.useState(false);
    var imageLoaded = imageLoadedState[0];
    var setImageLoaded = imageLoadedState[1];
    
    var imageErrorState = React.useState(false);
    var imageError = imageErrorState[0];
    var setImageError = imageErrorState[1];
    
    var imageUrl = getImageUrl ? getImageUrl(product) : 
                     (product.metafields && product.metafields['custom.customization_thumbnail']) || 
                     product.image || '';
    
    React.useEffect(function() {
        setImageLoaded(false);
        setImageError(false);
        
        if (!imageUrl) {
            setImageLoaded(true);
            return;
        }
        
        var img = new Image();
        img.onload = function() { setImageLoaded(true); };
        img.onerror = function() {
            setImageError(true);
            setImageLoaded(true);
        };
        img.src = imageUrl;
    }, [imageUrl]);
    
    return React.createElement('div', { 
        className: 'knife-option-wrapper', 
        onClick: function() { onSelect(product.id); }
    },
        React.createElement('div', { 
            className: 'knife-option' + (isSelected ? ' selected' : '') 
        },
            React.createElement('img', { 
                src: 'https://cdn.prod.website-files.com/68d5e9e73859fd3ba297c9c2/68db4ef3733a819133e47c95_card--tool-tip.svg', 
                alt: 'tooltip', 
                className: 'knife-tooltip', 
                onClick: function(e) { onTooltipClick(e, product); }
            }),
            React.createElement('div', { className: 'knife-placeholder' },
                !imageLoaded ? 
                    React.createElement('div', { className: 'card-skeleton-shimmer' }) :
                    (imageUrl && !imageError) ? 
                        React.createElement('img', { 
                            src: imageUrl, 
                            alt: product.name,
                            className: 'card-image-fade-in'
                        }) : 
                        '\u00A0'
            )
        ),
        React.createElement('div', { className: 'knife-name' }, product.name),
        showPrice && React.createElement('div', { className: 'knife-price' }, formatPrice(product.price))
    );
}

function KnifeShapeAccordion() {
    var selectedShapeState = React.useState(null);
    var selectedShape = selectedShapeState[0];
    var setSelectedShape = selectedShapeState[1];
    
    var expandedState = React.useState(true);
    var expanded = expandedState[0];
    var setExpanded = expandedState[1];
    
    var loadingState = React.useState(true);
    var loading = loadingState[0];
    var setLoading = loadingState[1];
    
    var knifeShapesState = React.useState([]);
    var knifeShapes = knifeShapesState[0];
    var setKnifeShapes = knifeShapesState[1];
    
    var filteredShapesState = React.useState([]);
    var filteredShapes = filteredShapesState[0];
    var setFilteredShapes = filteredShapesState[1];
    
    var hasLoadedState = React.useState(false);
    var hasLoaded = hasLoadedState[0];
    var setHasLoaded = hasLoadedState[1];
    
    var activeAccordionState = React.useState('shape');
    var activeAccordion = activeAccordionState[0];
    var setActiveAccordion = activeAccordionState[1];
    
    var popupOpenState = React.useState(false);
    var popupOpen = popupOpenState[0];
    var setPopupOpen = popupOpenState[1];
    
    var popupProductState = React.useState(null);
    var popupProduct = popupProductState[0];
    var setPopupProduct = popupProductState[1];
    
    var currentHandleFilterState = React.useState(null);
    var currentHandleFilter = currentHandleFilterState[0];
    var setCurrentHandleFilter = currentHandleFilterState[1];
    
    var accordionContentRef = React.useRef(null);
    
    React.useEffect(function() {
        window.KnifeCustomizationState.selectedShape = selectedShape;
        window.KnifeCustomizationState.setSelectedShape = setSelectedShape;
        window.KnifeCustomizationState.allShapes = knifeShapes;
    }, [selectedShape, knifeShapes]);
    
    React.useEffect(function() {
        var loadInitialData = function() {
            setLoading(true);
            setKnifeShapes(mockKnifeShapes);
            setFilteredShapes(mockKnifeShapes);
            setLoading(false);
            setHasLoaded(true);
        };
        loadInitialData();
    }, []);
    
    React.useEffect(function() {
        var checkState = setInterval(function() {
            if (window.KnifeCustomizationState.activeAccordion !== activeAccordion) {
                setActiveAccordion(window.KnifeCustomizationState.activeAccordion);
                if (window.KnifeCustomizationState.activeAccordion !== 'shape') {
                    setExpanded(false);
                }
            }
            if (window.KnifeCustomizationState.selectedShape !== selectedShape) {
                setSelectedShape(window.KnifeCustomizationState.selectedShape);
            }
            
            var currentHandle = window.KnifeCustomizationState.selectedHandleData;
            var handleId = currentHandle?.id || null;
            
            if (handleId !== currentHandleFilter) {
                setCurrentHandleFilter(handleId);
                
                if (currentHandle) {
                    var compatibleShapes = getCompatibleShapesFromHandle(currentHandle);
                    if (compatibleShapes.length > 0) {
                        var filtered = knifeShapes.filter(function(shape) {
                            return compatibleShapes.includes(shape.id);
                        });
                        setFilteredShapes(filtered);
                        
                        if (selectedShape && !compatibleShapes.includes(selectedShape)) {
                            setSelectedShape(null);
                            window.KnifeCustomizationState.selectedShape = null;
                        }
                    } else {
                        setFilteredShapes(knifeShapes);
                    }
                } else {
                    setFilteredShapes(knifeShapes);
                }
                
                if (accordionContentRef.current) {
                    accordionContentRef.current.scrollTop = 0;
                }
            }
        }, 50);
        return function() { clearInterval(checkState); };
    }, [activeAccordion, selectedShape, knifeShapes, currentHandleFilter]);
    
    var handleShapeSelect = function(shapeId) {
        setSelectedShape(shapeId);
        window.KnifeCustomizationState.selectedShape = shapeId;
        
        if (shapeId === null) {
            window.KnifeCustomizationState.selectedBlade = null;
            window.KnifeCustomizationState.selectedBladeData = null;
            if (window.KnifeCustomizationState.setSelectedBlade) {
                window.KnifeCustomizationState.setSelectedBlade(null);
            }
        } else {
            var currentBlade = window.KnifeCustomizationState.selectedBladeData;
            if (currentBlade && !bladeMatchesShape(currentBlade, shapeId)) {
                window.KnifeCustomizationState.selectedBlade = null;
                window.KnifeCustomizationState.selectedBladeData = null;
                if (window.KnifeCustomizationState.setSelectedBlade) {
                    window.KnifeCustomizationState.setSelectedBlade(null);
                }
            }
            
            var currentHandle = window.KnifeCustomizationState.selectedHandleData;
            if (currentHandle && !handleFitsShape(currentHandle, shapeId)) {
                window.KnifeCustomizationState.selectedHandle = null;
                window.KnifeCustomizationState.selectedHandleData = null;
                if (window.KnifeCustomizationState.setSelectedHandle) {
                    window.KnifeCustomizationState.setSelectedHandle(null);
                }
            }
        }
        
        console.log('Selected shape:', shapeId);
    };
    
    var handleTooltipClick = function(e, shape) {
        e.stopPropagation();
        setPopupProduct(shape);
        setPopupOpen(true);
    };
    
    var toggleAccordion = function() {
        var newExpanded = !expanded;
        if (newExpanded) {
            window.KnifeCustomizationState.activeAccordion = 'shape';
            setActiveAccordion('shape');
        } else {
            window.KnifeCustomizationState.activeAccordion = null;
            setActiveAccordion(null);
        }
        setExpanded(newExpanded);
    };
    
    var handleReset = function(e) {
        e.stopPropagation();
        handleShapeSelect(null);
    };
    
    var selectedShapeName = selectedShape ? filteredShapes.find(function(s) { return s.id === selectedShape; })?.name : null;
    
    var getShapeImage = function(shape) {
        return shapeImages[shape.id] || shape.image || '';
    };
    
    return React.createElement(React.Fragment, null,
        React.createElement('div', { className: 'knife-accordion' },
            React.createElement('div', { className: 'customization--option-dropdown', onClick: toggleAccordion, style: { cursor: 'pointer' } },
                React.createElement('div', { className: 'customization--option-left' },
                    React.createElement('img', { src: 'https://cdn.prod.website-files.com/68d5e9e73859fd3ba297c9c2/68d5f1947617349da379daa5_81c78d7f5feaffc4404affb586717860_customization-icon.svg', loading: 'lazy', width: '174', alt: '', className: 'customization-icon' }),
                    React.createElement('div', { className: 'customization--option-text' }, 'Select Your Knife Shape', selectedShapeName && ' - ' + selectedShapeName)
                ),
                React.createElement('img', { src: 'https://cdn.prod.website-files.com/68d5e9e73859fd3ba297c9c2/68d5f61874fb14ff18f15d86_customization-icon-right.svg', loading: 'lazy', alt: '', className: 'image' })
            ),
            React.createElement('div', { className: 'accordion-content' + (expanded ? ' expanded' : ''), ref: accordionContentRef },
                React.createElement('div', { className: 'reset-button-container' + (selectedShape && !loading ? ' visible' : '') },
                    React.createElement('div', { className: 'reset-button-inner' },
                        React.createElement('div', { className: 'reset-button', onClick: handleReset, style: { cursor: 'pointer' } },
                            React.createElement('div', { className: 'reset--button-text' }, 'RESET SELECTION'),
                            React.createElement('img', { src: 'https://cdn.prod.website-files.com/68d5e9e73859fd3ba297c9c2/68d64cf53de35dba15bd1f53_9ca7e0fa65307fe51373378192d8b7ee_reset-icon.svg', loading: 'lazy', width: 'Auto', alt: '', className: 'reset--button-icon' })
                        )
                    )
                ),
                React.createElement('div', { className: 'accordion-grid' },
                    loading ? React.createElement(SkeletonLoader, { count: 8 }) :
                    filteredShapes.length === 0 ?
                        React.createElement('div', { 
                            style: { 
                                gridColumn: '1 / -1', 
                                textAlign: 'center', 
                                padding: '40px 20px',
                                color: 'rgba(255, 255, 255, 0.2)',
                                fontSize: '14px',
                                textAlign: 'center',
                                whiteSpace: 'nowrap'
                            } 
                        }, 'No shapes available for selected handle') :
                    filteredShapes.map(function(shape) {
                        return React.createElement(ProductCard, {
                            key: shape.id,
                            product: shape,
                            isSelected: selectedShape === shape.id,
                            onSelect: handleShapeSelect,
                            onTooltipClick: handleTooltipClick,
                            showPrice: false,
                            getImageUrl: getShapeImage
                        });
                    })
                )
            )
        ),
        React.createElement(ProductPopup, { isOpen: popupOpen, onClose: function() { setPopupOpen(false); }, product: popupProduct, imageType: 'shape' })
    );
}

function BladeTypeAccordion() {
    var selectedBladeState = React.useState(null);
    var selectedBlade = selectedBladeState[0];
    var setSelectedBlade = selectedBladeState[1];
    
    var expandedState = React.useState(false);
    var expanded = expandedState[0];
    var setExpanded = expandedState[1];
    
    var loadingState = React.useState(false);
    var loading = loadingState[0];
    var setLoading = loadingState[1];
    
    var bladeTypesState = React.useState([]);
    var bladeTypes = bladeTypesState[0];
    var setBladeTypes = bladeTypesState[1];
    
    var allBladesState = React.useState([]);
    var allBlades = allBladesState[0];
    var setAllBlades = allBladesState[1];
    
    var hasLoadedAllState = React.useState(false);
    var hasLoadedAll = hasLoadedAllState[0];
    var setHasLoadedAll = hasLoadedAllState[1];
    
    var activeAccordionState = React.useState(null);
    var activeAccordion = activeAccordionState[0];
    var setActiveAccordion = activeAccordionState[1];
    
    var popupOpenState = React.useState(false);
    var popupOpen = popupOpenState[0];
    var setPopupOpen = popupOpenState[1];
    
    var popupProductState = React.useState(null);
    var popupProduct = popupProductState[0];
    var setPopupProduct = popupProductState[1];
    
    var currentFilterShapeState = React.useState(null);
    var currentFilterShape = currentFilterShapeState[0];
    var setCurrentFilterShape = currentFilterShapeState[1];
    
    var currentFilterHandleState = React.useState(null);
    var currentFilterHandle = currentFilterHandleState[0];
    var setCurrentFilterHandle = currentFilterHandleState[1];
    
    var accordionContentRef = React.useRef(null);
    
    React.useEffect(function() {
        window.KnifeCustomizationState.selectedBlade = selectedBlade;
        window.KnifeCustomizationState.setSelectedBlade = setSelectedBlade;
        window.KnifeCustomizationState.allBlades = allBlades;
    }, [selectedBlade, allBlades]);
    
    var filterBlades = React.useCallback(function(blades, shapeId, handleData) {
        var filtered = blades.slice();
        
        if (shapeId) {
            filtered = filtered.filter(function(blade) {
                return bladeMatchesShape(blade, shapeId);
            });
        }
        else if (handleData) {
            var compatibleShapes = getCompatibleShapesFromHandle(handleData);
            if (compatibleShapes.length > 0) {
                filtered = filtered.filter(function(blade) {
                    var bladeShape = getShapeFromBladeTags(blade.tags);
                    return bladeShape && compatibleShapes.includes(bladeShape);
                });
            }
        }
        
        if (handleData && handleHasBladeRestrictions(handleData)) {
            filtered = filtered.filter(function(blade) {
                return bladeFitsHandle(blade, handleData);
            });
        }
        
        return filtered;
    }, []);
    
    React.useEffect(function() {
        var checkState = setInterval(function() {
            if (window.KnifeCustomizationState.activeAccordion !== activeAccordion) {
                setActiveAccordion(window.KnifeCustomizationState.activeAccordion);
                if (window.KnifeCustomizationState.activeAccordion !== 'blade') {
                    setExpanded(false);
                }
            }
            
            var currentShape = window.KnifeCustomizationState.selectedShape;
            var currentHandle = window.KnifeCustomizationState.selectedHandleData;
            var handleId = currentHandle?.id || null;
            
            if (currentShape !== currentFilterShape || handleId !== currentFilterHandle) {
                setCurrentFilterShape(currentShape);
                setCurrentFilterHandle(handleId);
                
                if (hasLoadedAll && allBlades.length > 0) {
                    var filtered = filterBlades(allBlades, currentShape, currentHandle);
                    setBladeTypes(filtered);
                    
                    if (selectedBlade) {
                        var stillExists = filtered.some(function(b) { return b.id === selectedBlade; });
                        if (!stillExists) {
                            setSelectedBlade(null);
                            window.KnifeCustomizationState.selectedBlade = null;
                            window.KnifeCustomizationState.selectedBladeData = null;
                        }
                    }
                    
                    if (accordionContentRef.current) {
                        accordionContentRef.current.scrollTop = 0;
                    }
                }
            }
        }, 50);
        return function() { clearInterval(checkState); };
    }, [activeAccordion, currentFilterShape, currentFilterHandle, hasLoadedAll, allBlades, selectedBlade, filterBlades]);
    
    var handleBladeSelect = function(bladeId) {
        var blade = allBlades.find(function(b) { return b.id === bladeId; });
        setSelectedBlade(bladeId);
        window.KnifeCustomizationState.selectedBlade = bladeId;
        window.KnifeCustomizationState.selectedBladeData = blade || null;
        
        if (blade) {
            var shapeFromBlade = getShapeFromBladeTags(blade.tags);
            if (shapeFromBlade && shapeFromBlade !== window.KnifeCustomizationState.selectedShape) {
                window.KnifeCustomizationState.selectedShape = shapeFromBlade;
                if (window.KnifeCustomizationState.setSelectedShape) {
                    window.KnifeCustomizationState.setSelectedShape(shapeFromBlade);
                }
                setCurrentFilterShape(shapeFromBlade);
                
                var currentHandle = window.KnifeCustomizationState.selectedHandleData;
                if (currentHandle && !handleFitsShape(currentHandle, shapeFromBlade)) {
                    window.KnifeCustomizationState.selectedHandle = null;
                    window.KnifeCustomizationState.selectedHandleData = null;
                    if (window.KnifeCustomizationState.setSelectedHandle) {
                        window.KnifeCustomizationState.setSelectedHandle(null);
                    }
                }
            }
            
            var currentHandle = window.KnifeCustomizationState.selectedHandleData;
            if (currentHandle && !bladeFitsHandle(blade, currentHandle)) {
                window.KnifeCustomizationState.selectedHandle = null;
                window.KnifeCustomizationState.selectedHandleData = null;
                if (window.KnifeCustomizationState.setSelectedHandle) {
                    window.KnifeCustomizationState.setSelectedHandle(null);
                }
            }
        }
        
        console.log('Selected blade:', bladeId);
    };
    
    var handleTooltipClick = function(e, blade) {
        e.stopPropagation();
        setPopupProduct(blade);
        setPopupOpen(true);
    };
    
    var toggleAccordion = function() {
        var newExpanded = !expanded;
        if (newExpanded) {
            window.KnifeCustomizationState.activeAccordion = 'blade';
            setActiveAccordion('blade');
        } else {
            window.KnifeCustomizationState.activeAccordion = null;
            setActiveAccordion(null);
        }
        setExpanded(newExpanded);
        
        if (newExpanded && !hasLoadedAll) {
            setLoading(true);
            window.fetchProducts('blades').then(function(data) {
                setAllBlades(data);
                window.KnifeCustomizationState.allBlades = data;
                
                var currentShape = window.KnifeCustomizationState.selectedShape;
                var currentHandle = window.KnifeCustomizationState.selectedHandleData;
                var filtered = filterBlades(data, currentShape, currentHandle);
                setBladeTypes(filtered);
                
                setHasLoadedAll(true);
                setLoading(false);
            }).catch(function(error) {
                console.error('Failed to fetch blades:', error);
                setBladeTypes([]);
                setAllBlades([]);
                setLoading(false);
            });
        }
    };
    
    var handleReset = function(e) {
        e.stopPropagation();
        setSelectedBlade(null);
        window.KnifeCustomizationState.selectedBlade = null;
        window.KnifeCustomizationState.selectedBladeData = null;
        
        // Also reset shape
        window.KnifeCustomizationState.selectedShape = null;
        if (window.KnifeCustomizationState.setSelectedShape) {
            window.KnifeCustomizationState.setSelectedShape(null);
        }
    };
    
    var selectedBladeName = selectedBlade ? bladeTypes.find(function(b) { return b.id === selectedBlade; })?.name : null;
    
    var getBladeImage = function(blade) {
        return (blade.metafields && blade.metafields['custom.customization_thumbnail']) || blade.image || '';
    };
    
    return React.createElement(React.Fragment, null,
        React.createElement('div', { className: 'knife-accordion' },
            React.createElement('div', { className: 'customization--option-dropdown', onClick: toggleAccordion, style: { cursor: 'pointer' } },
                React.createElement('div', { className: 'customization--option-left' },
                    React.createElement('img', { src: 'https://cdn.prod.website-files.com/68d5e9e73859fd3ba297c9c2/68d5f1947617349da379daa5_81c78d7f5feaffc4404affb586717860_customization-icon.svg', loading: 'lazy', width: '174', alt: '', className: 'customization-icon' }),
                    React.createElement('div', { className: 'customization--option-text' }, 'Select Your Blade Type', selectedBladeName && ' - ' + selectedBladeName)
                ),
                React.createElement('img', { src: 'https://cdn.prod.website-files.com/68d5e9e73859fd3ba297c9c2/68d5f61874fb14ff18f15d86_customization-icon-right.svg', loading: 'lazy', alt: '', className: 'image' })
            ),
            React.createElement('div', { className: 'accordion-content' + (expanded ? ' expanded' : ''), ref: accordionContentRef },
                React.createElement('div', { className: 'reset-button-container' + (selectedBlade && !loading ? ' visible' : '') },
                    React.createElement('div', { className: 'reset-button-inner' },
                        React.createElement('div', { className: 'reset-button', onClick: handleReset, style: { cursor: 'pointer' } },
                            React.createElement('div', { className: 'reset--button-text' }, 'RESET SELECTION'),
                            React.createElement('img', { src: 'https://cdn.prod.website-files.com/68d5e9e73859fd3ba297c9c2/68d64cf53de35dba15bd1f53_9ca7e0fa65307fe51373378192d8b7ee_reset-icon.svg', loading: 'lazy', width: 'Auto', alt: '', className: 'reset--button-icon' })
                        )
                    )
                ),
                React.createElement('div', { className: 'accordion-grid' },
                    loading ? React.createElement(SkeletonLoader, { count: 4 }) :
                    bladeTypes.length === 0 ? 
                        React.createElement('div', { 
                            style: { 
                                gridColumn: '1 / -1', 
                                textAlign: 'center', 
                                padding: '40px 20px',
                                color: 'rgba(255, 255, 255, 0.2)',
                                fontSize: '14px',
                                textAlign: 'center',
                                whiteSpace: 'nowrap'
                            } 
                        }, 'No blade types available') :
                    bladeTypes.map(function(blade) {
                        return React.createElement(ProductCard, {
                            key: blade.id,
                            product: blade,
                            isSelected: selectedBlade === blade.id,
                            onSelect: handleBladeSelect,
                            onTooltipClick: handleTooltipClick,
                            showPrice: true,
                            getImageUrl: getBladeImage
                        });
                    })
                )
            )
        ),
        React.createElement(ProductPopup, { isOpen: popupOpen, onClose: function() { setPopupOpen(false); }, product: popupProduct, imageType: 'blade' })
    );
}

function HandleTypeAccordion() {
    var selectedHandleState = React.useState(null);
    var selectedHandle = selectedHandleState[0];
    var setSelectedHandle = selectedHandleState[1];
    
    var expandedState = React.useState(false);
    var expanded = expandedState[0];
    var setExpanded = expandedState[1];
    
    var loadingState = React.useState(false);
    var loading = loadingState[0];
    var setLoading = loadingState[1];
    
    var handleTypesState = React.useState([]);
    var handleTypes = handleTypesState[0];
    var setHandleTypes = handleTypesState[1];
    
    var allHandlesState = React.useState([]);
    var allHandles = allHandlesState[0];
    var setAllHandles = allHandlesState[1];
    
    var hasLoadedAllState = React.useState(false);
    var hasLoadedAll = hasLoadedAllState[0];
    var setHasLoadedAll = hasLoadedAllState[1];
    
    var activeAccordionState = React.useState(null);
    var activeAccordion = activeAccordionState[0];
    var setActiveAccordion = activeAccordionState[1];
    
    var popupOpenState = React.useState(false);
    var popupOpen = popupOpenState[0];
    var setPopupOpen = popupOpenState[1];
    
    var popupProductState = React.useState(null);
    var popupProduct = popupProductState[0];
    var setPopupProduct = popupProductState[1];
    
    var currentFilterShapeState = React.useState(null);
    var currentFilterShape = currentFilterShapeState[0];
    var setCurrentFilterShape = currentFilterShapeState[1];
    
    var currentFilterBladeState = React.useState(null);
    var currentFilterBlade = currentFilterBladeState[0];
    var setCurrentFilterBlade = currentFilterBladeState[1];
    
    var accordionContentRef = React.useRef(null);
    
    React.useEffect(function() {
        window.KnifeCustomizationState.selectedHandle = selectedHandle;
        window.KnifeCustomizationState.setSelectedHandle = setSelectedHandle;
        window.KnifeCustomizationState.allHandles = allHandles;
    }, [selectedHandle, allHandles]);
    
    var filterHandles = React.useCallback(function(handles, shapeId, bladeData) {
        var filtered = handles.slice();
        
        if (shapeId) {
            filtered = filtered.filter(function(handle) {
                return handleFitsShape(handle, shapeId);
            });
        }
        
        if (bladeData) {
            filtered = filtered.filter(function(handle) {
                return handleFitsBlade(handle, bladeData);
            });
        }
        
        return filtered;
    }, []);
    
    React.useEffect(function() {
        var checkState = setInterval(function() {
            if (window.KnifeCustomizationState.activeAccordion !== activeAccordion) {
                setActiveAccordion(window.KnifeCustomizationState.activeAccordion);
                if (window.KnifeCustomizationState.activeAccordion !== 'handle') {
                    setExpanded(false);
                }
            }
            
            var currentShape = window.KnifeCustomizationState.selectedShape;
            var currentBlade = window.KnifeCustomizationState.selectedBladeData;
            var bladeId = currentBlade?.id || null;
            
            if (currentShape !== currentFilterShape || bladeId !== currentFilterBlade) {
                setCurrentFilterShape(currentShape);
                setCurrentFilterBlade(bladeId);
                
                if (hasLoadedAll && allHandles.length > 0) {
                    var filtered = filterHandles(allHandles, currentShape, currentBlade);
                    setHandleTypes(filtered);
                    
                    if (selectedHandle) {
                        var stillExists = filtered.some(function(h) { return h.id === selectedHandle; });
                        if (!stillExists) {
                            setSelectedHandle(null);
                            window.KnifeCustomizationState.selectedHandle = null;
                            window.KnifeCustomizationState.selectedHandleData = null;
                        }
                    }
                    
                    if (accordionContentRef.current) {
                        accordionContentRef.current.scrollTop = 0;
                    }
                }
            }
        }, 50);
        return function() { clearInterval(checkState); };
    }, [activeAccordion, currentFilterShape, currentFilterBlade, hasLoadedAll, allHandles, selectedHandle, filterHandles]);
    
    var handleHandleSelect = function(handleId) {
        var handle = allHandles.find(function(h) { return h.id === handleId; });
        setSelectedHandle(handleId);
        window.KnifeCustomizationState.selectedHandle = handleId;
        window.KnifeCustomizationState.selectedHandleData = handle || null;
        
        if (handle) {
            var compatibleShapes = getCompatibleShapesFromHandle(handle);
            var currentShape = window.KnifeCustomizationState.selectedShape;
            
            if (currentShape && !compatibleShapes.includes(currentShape)) {
                window.KnifeCustomizationState.selectedShape = null;
                if (window.KnifeCustomizationState.setSelectedShape) {
                    window.KnifeCustomizationState.setSelectedShape(null);
                }
                
                var currentBlade = window.KnifeCustomizationState.selectedBladeData;
                if (currentBlade) {
                    var bladeShape = getShapeFromBladeTags(currentBlade.tags);
                    if (bladeShape && !compatibleShapes.includes(bladeShape)) {
                        window.KnifeCustomizationState.selectedBlade = null;
                        window.KnifeCustomizationState.selectedBladeData = null;
                        if (window.KnifeCustomizationState.setSelectedBlade) {
                            window.KnifeCustomizationState.setSelectedBlade(null);
                        }
                    }
                }
            }
            else {
                var currentBlade = window.KnifeCustomizationState.selectedBladeData;
                if (currentBlade) {
                    var bladeShape = getShapeFromBladeTags(currentBlade.tags);
                    if (bladeShape && !compatibleShapes.includes(bladeShape)) {
                        window.KnifeCustomizationState.selectedBlade = null;
                        window.KnifeCustomizationState.selectedBladeData = null;
                        window.KnifeCustomizationState.selectedShape = null;
                        if (window.KnifeCustomizationState.setSelectedBlade) {
                            window.KnifeCustomizationState.setSelectedBlade(null);
                        }
                        if (window.KnifeCustomizationState.setSelectedShape) {
                            window.KnifeCustomizationState.setSelectedShape(null);
                        }
                    }
                    else {
                        if (!bladeFitsHandle(currentBlade, handle)) {
                            window.KnifeCustomizationState.selectedBlade = null;
                            window.KnifeCustomizationState.selectedBladeData = null;
                            window.KnifeCustomizationState.selectedShape = null;
                            if (window.KnifeCustomizationState.setSelectedBlade) {
                                window.KnifeCustomizationState.setSelectedBlade(null);
                            }
                            if (window.KnifeCustomizationState.setSelectedShape) {
                                window.KnifeCustomizationState.setSelectedShape(null);
                            }
                        }
                    }
                }
            }
        }
        
        console.log('Selected handle:', handleId);
    };
    
    var handleTooltipClick = function(e, handle) {
        e.stopPropagation();
        setPopupProduct(handle);
        setPopupOpen(true);
    };
    
    var toggleAccordion = function() {
        var newExpanded = !expanded;
        if (newExpanded) {
            window.KnifeCustomizationState.activeAccordion = 'handle';
            setActiveAccordion('handle');
        } else {
            window.KnifeCustomizationState.activeAccordion = null;
            setActiveAccordion(null);
        }
        setExpanded(newExpanded);
        
        if (newExpanded && !hasLoadedAll) {
            setLoading(true);
            window.fetchProducts('handles').then(function(data) {
                setAllHandles(data);
                window.KnifeCustomizationState.allHandles = data;
                
                var currentShape = window.KnifeCustomizationState.selectedShape;
                var currentBlade = window.KnifeCustomizationState.selectedBladeData;
                var filtered = filterHandles(data, currentShape, currentBlade);
                setHandleTypes(filtered);
                
                setHasLoadedAll(true);
                setLoading(false);
            }).catch(function(error) {
                console.error('Failed to fetch handles:', error);
                setHandleTypes([]);
                setAllHandles([]);
                setLoading(false);
            });
        }
    };
    
    var handleReset = function(e) {
        e.stopPropagation();
        setSelectedHandle(null);
        window.KnifeCustomizationState.selectedHandle = null;
        window.KnifeCustomizationState.selectedHandleData = null;
    };
    
    var selectedHandleName = selectedHandle ? handleTypes.find(function(h) { return h.id === selectedHandle; })?.name : null;
    
    var getHandleImage = function(handle) {
        return (handle.metafields && handle.metafields['custom.customization_thumbnail']) || handle.image || '';
    };
    
    return React.createElement(React.Fragment, null,
        React.createElement('div', { className: 'knife-accordion' },
            React.createElement('div', { className: 'customization--option-dropdown', onClick: toggleAccordion, style: { cursor: 'pointer' } },
                React.createElement('div', { className: 'customization--option-left' },
                    React.createElement('img', { src: 'https://cdn.prod.website-files.com/68d5e9e73859fd3ba297c9c2/68d5f1947617349da379daa5_81c78d7f5feaffc4404affb586717860_customization-icon.svg', loading: 'lazy', width: '174', alt: '', className: 'customization-icon' }),
                    React.createElement('div', { className: 'customization--option-text' }, 'Select Your Handle Type', selectedHandleName && ' - ' + selectedHandleName)
                ),
                React.createElement('img', { src: 'https://cdn.prod.website-files.com/68d5e9e73859fd3ba297c9c2/68d5f61874fb14ff18f15d86_customization-icon-right.svg', loading: 'lazy', alt: '', className: 'image' })
            ),
            React.createElement('div', { className: 'accordion-content' + (expanded ? ' expanded' : ''), ref: accordionContentRef },
                React.createElement('div', { className: 'reset-button-container' + (selectedHandle && !loading ? ' visible' : '') },
                    React.createElement('div', { className: 'reset-button-inner' },
                        React.createElement('div', { className: 'reset-button', onClick: handleReset, style: { cursor: 'pointer' } },
                            React.createElement('div', { className: 'reset--button-text' }, 'RESET SELECTION'),
                            React.createElement('img', { src: 'https://cdn.prod.website-files.com/68d5e9e73859fd3ba297c9c2/68d64cf53de35dba15bd1f53_9ca7e0fa65307fe51373378192d8b7ee_reset-icon.svg', loading: 'lazy', width: 'Auto', alt: '', className: 'reset--button-icon' })
                        )
                    )
                ),
                React.createElement('div', { className: 'accordion-grid' },
                    loading ? React.createElement(SkeletonLoader, { count: 4 }) :
                    handleTypes.length === 0 ? 
                        React.createElement('div', { 
                            style: { 
                                gridColumn: '1 / -1', 
                                textAlign: 'center', 
                                padding: '40px 20px',
                                color: 'rgba(255, 255, 255, 0.2)',
                                fontSize: '14px',
                                textAlign: 'center',
                                whiteSpace: 'nowrap'
                            } 
                        }, 'No handles available') :
                    handleTypes.map(function(handle) {
                        return React.createElement(ProductCard, {
                            key: handle.id,
                            product: handle,
                            isSelected: selectedHandle === handle.id,
                            onSelect: handleHandleSelect,
                            onTooltipClick: handleTooltipClick,
                            showPrice: true,
                            getImageUrl: getHandleImage
                        });
                    })
                )
            )
        ),
        React.createElement(ProductPopup, { isOpen: popupOpen, onClose: function() { setPopupOpen(false); }, product: popupProduct, imageType: 'handle' })
    );
}

window.KnifeShapeAccordion = KnifeShapeAccordion;
window.BladeTypeAccordion = BladeTypeAccordion;
window.HandleTypeAccordion = HandleTypeAccordion;
